<template>
    <article class="media">
        <div class="media-content">
            <div>
                <div class="comment-header">
                    <strong :title="comment.author.email">{{ comment.author.name }}</strong>
                    <span class="comment-items">
                        <a
                            class="comment-edit"
                            v-if="isEditable"
                            :title="trans.edit_comment"
                            @click.prevent="showEditCommentForm"
                        >
                            <svg>
                                <use xlink:href="#icon-pencil"></use>
                            </svg>
                        </a>
                        <a
                            class="comment-delete"
                            v-if="isDeleteble"
                            :title="trans.delete_comment"
                            @click.prevent="showConfirmDeletionModal"
                        >
                            <svg>
                                <use xlink:href="#icon-cross"></use>
                            </svg>
                        </a>
                    </span>
                </div>
                <component
                    class="comment-content"
                    :is="selectedComponent"
                    :commentText="comment.body"
                    @done="changeComponent"
                />
            </div>
            <nav>
                <ul>
                    <li class="comment-footer">{{ createdAt }}</li>
                </ul>
            </nav>
        </div>
    </article>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CommentDeletionConfirmationModal from "./CommentDeletionConfirmationModal";
import CommentBody from "./CommentBody";

export default {
    name: "Comment",
    components: {
        CommentBody,
        EditComment: () => import("./EditComment"),
        CommentDeletionConfirmationModal,
    },
    props: ['comment'],
    data() {
        return {
            selectedComponent: 'CommentBody',
        }
    },
    computed: {
        createdAt() {
            return this._dateTimeFormat(this.comment.created_at);
        },
        updatedAt() {
            return this._dateTimeFormat(this.comment.updated_at);
        },
        isEditable() {
            return this.currentUser === this.comment.author.email && !this.isEditingBlocked;
        },
        isDeleteble() {
            return this.isUserCanManageComments
                || this.currentUser === this.comment.author.email
                && !this.isEditingBlocked;
        },
        ...mapGetters('comment', [
            'trans',
            'currentUser',
            'isEditingBlocked',
            'isUserCanManageComments',
        ]),
    },
    methods: {
        ...mapActions('comment', [
            'setEditingBlocked',
            'unsetEditingBlocked',
            'editComment',
            'setCommentHash',
            'showDeletionConfirmationModal',
        ]),
        showConfirmDeletionModal() {
            this.setCommentHash(this.comment.hash_id);
            this.showDeletionConfirmationModal();
        },
        showEditCommentForm() {
            this.setEditingBlocked(true);
            this.setCommentHash(this.comment.hash_id);
            this.selectedComponent = 'EditComment';
        },
        changeComponent() {
            this.selectedComponent = 'CommentBody';
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    strong {
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 19px;
    }
    .bulma span a {
        padding-left: 14px;
    }
    .comment-header {
        display: flex;
        align-items: center;
        min-height: 25px;
    }
    article {
        &:hover .comment-items {
            display: flex;
        }
    }
    .comment-items {
        display: none;
    }
    .comment-edit {
        &:hover {

            svg {
                fill: $info;
            }
        }
    }
    .comment-delete {
        &:hover {
            svg {
                fill: $danger;
            }
        }
    }
    svg {
        width: 16px;
        height: 16px;
        fill: $grey;
    }
    .comment-content {
        margin-top: 5px;
        margin-bottom: 5px;
    }
    .comment-items {
        margin-left: auto;
        margin-right: 5px;
    }
    .comment-footer {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 24px;
        color: #838383;
    }
    .bulma .media + .media {
        border-top: 1px solid #DEDEDE;
        margin-top: 1rem;
        padding-top: 1rem;
    }
    .bulma .breadcrumbs a {
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 24px;
        color: #2B67DF;
    }
    div.content {
        padding-left: 0px;
        width: calc(100% - 2px);
        padding-right: 0px;
    }
</style>
